import React from "react";
import { useFormContext } from "react-hook-form";
import useOptionallyControlled from "../hooks/useOptionallyControlled";

import "../style/inputs.scss";

function TextArea({
    label, // label text next to textarea
    name, // name of the textarea for forms stuff
    placeholder,
    value: controlledValue,
    formOptions,
    disabled,
    helpText, // optional help text below textarea
    onChange,
    noShrink = false, // prevent this from collapsing when label / help is empty
    style = {},
    className = "",
    textAreaClassName = "input-bordered",
    textAreaStyle = {}, // for the inner textarea itself, prefer using style instead and reserve this for when that is insufficient
    ...restProps // any extra props go right to the underlying textarea element
}) {
    const formContext = useFormContext();
    const [propsForTextarea] = useOptionallyControlled(name, controlledValue, onChange, formOptions);

    const textareaId = `textarea-${name}`;

    const error = formContext?.formState?.errors?.[name]?.message;

    const infoOrError = error || helpText;

    return (
        <div
            className={`
        input-container
        ${error ? "error" : ""}
        ${disabled ? "disabled" : ""}
        ${className}
      `}
            style={{
                maxWidth: "100%",
                width: "fit-content",
                ...style,
            }}
        >
            {/* TOP LABEL */}
            <label
                className={`input-label`}
                style={{
                    visibility: label ? "visible" : "hidden", // hide label if no label
                }}
            >
                {label || (noShrink ? "\u00A0" : "")}
            </label>

            {/* TEXTAREA */}
            <textarea
                id={textareaId}
                className={textAreaClassName}
                placeholder={placeholder}
                disabled={disabled}
                {...propsForTextarea}
                style={{
                    minWidth: "100%",
                    minHeight: "3.25em",
                    height: "80px",
                    resize: "both",
                    maxWidth: "100%",
                    ...textAreaStyle,
                }}
                {...restProps}
            />

            {/* BOTTOM INFO/ERROR TEXT */}
            <span
                className="input-info-text"
                style={{
                    visibility: infoOrError ? "visible" : "hidden", // hide if no text here
                }}
            >{`${infoOrError || (noShrink ? "\u00A0" : "")}`}</span>
        </div>
    );
}

export default TextArea;
